import copy from 'copy-to-clipboard';

export const copyToClipboard = (text: string): void | Promise<void> => {
	// universal library that should work on all browsers
	const success = copy(text, {
		debug: process.env['NX_PUBLIC_RELEASE_DIST'] !== 'prod',
	});

	if (success) {
		return;
	}

	// document.execCommand("copy") is deprecated
	if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
		const range = document.createRange();
		const textField = document.createElement('textarea');
		textField.value = text;
		textField.style.position = 'fixed';
		textField.style.top = '0';
		textField.style.left = '0';
		textField.style.zIndex = '-1';
		document.body.appendChild(textField);
		range.selectNode(textField);
		window.getSelection()?.removeAllRanges();
		window.getSelection()?.addRange(range);
		document.execCommand('copy');
		window.getSelection()?.removeAllRanges();
		textField.remove();

		return;
	}

	// sadly does not work on mac and ios
	if (
		'navigator' in window &&
		typeof navigator !== 'undefined' &&
		typeof navigator.clipboard !== 'undefined' &&
		typeof navigator.permissions !== 'undefined'
	) {
		return window.navigator.clipboard.writeText(text);
	}
};
